/* tslint:disable */
/* eslint-disable */
/**
 * Payment service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { BeginBillCreditPaymentResponse } from '../model';
// @ts-ignore
import { ChangeBillPaymentStatusRequest } from '../model';
// @ts-ignore
import { PaymentGatewaysDto } from '../model';
// @ts-ignore
import { PaymentServiceTypes } from '../model';
/**
 * BillPaymentApiApiBillPaymentChangeBillPaymentStatuePost - axios parameter creator
 * 
 * @param {ChangeBillPaymentStatusRequest} [changeBillPaymentStatusRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillPaymentApiApiBillPaymentChangeBillPaymentStatuePostAxiosParamCreator (changeBillPaymentStatusRequest?: ChangeBillPaymentStatusRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/BillPayment/changeBillPaymentStatue`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(changeBillPaymentStatusRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillPaymentApiApiBillPaymentCreditBillCodePost - axios parameter creator
 * 
 * @summary start bill payment but only credit one
 * @param {string} billCode 
 * @param {boolean} [fastMode] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillPaymentApiApiBillPaymentCreditBillCodePostAxiosParamCreator (billCode: string, fastMode?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillPaymentCreditBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/BillPayment/credit/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fastMode !== undefined) {
        localVarQueryParameter['fastMode'] = fastMode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillPaymentApiApiBillPaymentGatewaysPost - axios parameter creator
 * 
 * @param {PaymentServiceTypes} [serviceType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillPaymentApiApiBillPaymentGatewaysPostAxiosParamCreator (serviceType?: PaymentServiceTypes, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/BillPayment/gateways`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (serviceType !== undefined) {
        localVarQueryParameter['serviceType'] = serviceType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiBillPaymentChangeBillPaymentStatuePost operation in BillPaymentApi.
 * @export
 * @interface BillPaymentApiApiBillPaymentChangeBillPaymentStatuePostRequest
 */
export interface BillPaymentApiApiBillPaymentChangeBillPaymentStatuePostRequest {
    /**
     * 
     * @type {ChangeBillPaymentStatusRequest}
     * @memberof BillPaymentApiApiBillPaymentChangeBillPaymentStatuePost
     */
    readonly changeBillPaymentStatusRequest?: ChangeBillPaymentStatusRequest
}

/**
 * Request parameters for apiBillPaymentCreditBillCodePost operation in BillPaymentApi.
 * @export
 * @interface BillPaymentApiApiBillPaymentCreditBillCodePostRequest
 */
export interface BillPaymentApiApiBillPaymentCreditBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof BillPaymentApiApiBillPaymentCreditBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {boolean}
     * @memberof BillPaymentApiApiBillPaymentCreditBillCodePost
     */
    readonly fastMode?: boolean
}

/**
 * Request parameters for apiBillPaymentGatewaysPost operation in BillPaymentApi.
 * @export
 * @interface BillPaymentApiApiBillPaymentGatewaysPostRequest
 */
export interface BillPaymentApiApiBillPaymentGatewaysPostRequest {
    /**
     * 
     * @type {PaymentServiceTypes}
     * @memberof BillPaymentApiApiBillPaymentGatewaysPost
     */
    readonly serviceType?: PaymentServiceTypes
}

/**
* 
* @param {BillPaymentApiApiBillPaymentChangeBillPaymentStatuePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillPaymentApiApiBillPaymentChangeBillPaymentStatuePost(requestParameters: BillPaymentApiApiBillPaymentChangeBillPaymentStatuePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillPaymentApiApiBillPaymentChangeBillPaymentStatuePostAxiosParamCreator(requestParameters.changeBillPaymentStatusRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary start bill payment but only credit one
* @param {BillPaymentApiApiBillPaymentCreditBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillPaymentApiApiBillPaymentCreditBillCodePost(requestParameters: BillPaymentApiApiBillPaymentCreditBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillPaymentApiApiBillPaymentCreditBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.fastMode, options, configuration);
    const request: () => AxiosPromise<BeginBillCreditPaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillPaymentApiApiBillPaymentGatewaysPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillPaymentApiApiBillPaymentGatewaysPost(requestParameters: BillPaymentApiApiBillPaymentGatewaysPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillPaymentApiApiBillPaymentGatewaysPostAxiosParamCreator(requestParameters.serviceType, options, configuration);
    const request: () => AxiosPromise<PaymentGatewaysDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
